import { BOOK_PUBLISHER_DETAILS } from "../../types/BookPublisherType";
import axios from "axios";

const detailBookPublisher = (data) => {
	return {
		type: BOOK_PUBLISHER_DETAILS,
		payload: data,
	};
};

export const loadSingleBookPublisher = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const data = await axios.get(`book-publisher/${id}`);
			//dispatching data
			dispatch(detailBookPublisher(data));
			return data;
		} catch (error) {
			console.log(error.message);
		}
	};
};
